import R from 'ramda';
import utils from './utils';

const URL = `${BASE_API_URL}/auth`;

export default {
    resetPassword: (email, nextUrl, hash) => utils.post(`${URL}/password_reset.json?${concatParams(email, nextUrl, hash)}`),
}

const concatParams = (email, nextUrl, hash) => {
    const params = [`email=${encodeURIComponent(email)}`];
    if (nextUrl) {
        params.push(`url=${encodeURIComponent(nextUrl)}`);
    }
    if (hash) {
        params.push(`hash=${encodeURIComponent(hash)}`);
    }
    return R.join('&', params);
};



// WEBPACK FOOTER //
// ./src/api/auth.js